const AtogList = () => {
    return (<ul className='list-none'>
        <li>1x Adaptive Automaton</li>
        <li>1x Amoeboid Changeling</li>
        <li>1x Arcane Signet</li>
        <li>1x Ash Barrens</li>
        <li>1x Atog</li>
        <li>1x Atogatog</li>
        <li>1x Auratog</li>
        <li>1x Barren Glory</li>
        <li>1x Black Market Connections</li>
        <li>1x Bloodline Pretender</li>
        <li>1x Borne Upon a Wind</li>
        <li>1x Buried Ruin</li>
        <li>1x Burning Anger</li>
        <li>1x Chameleon Colossus</li>
        <li>1x Chandra's Ignition</li>
        <li>1x Changeling Outcast</li>
        <li>1x Channel the Suns</li>
        <li>1x Chromatic Lantern</li>
        <li>1x Chronatog Totem</li>
        <li>1x Circuitous Route</li>
        <li>1x Coat of Arms</li>
        <li>1x Command Tower</li>
        <li>1x Commander's Sphere</li>
        <li>1x Conflux</li>
        <li>1x Darkwater Catacombs</li>
        <li>1x Diabolic Tutor</li>
        <li>1x Distant Melody</li>
        <li>1x Doomsday</li>
        <li>1x Essence Harvest</li>
        <li>1x Eternal Witness</li>
        <li>1x Exotic Orchard</li>
        <li>1x Farseek</li>
        <li>1x Foratog</li>
        <li>4x Forest</li>
        <li>1x Ghostly Changeling</li>
        <li>1x Graveshifter</li>
        <li>1x Gravitic Punch</li>
        <li>1x Great Furnace</li>
        <li>1x Herald's Horn</li>
        <li>1x Impostor of the Sixth Pride</li>
        <li>1x Irregular Cohort</li>
        <li>4x Island</li>
        <li>1x Kodama's Reach</li>
        <li>1x Lifeline</li>
        <li>1x Lithatog</li>
        <li>1x Masked Vandal</li>
        <li>1x Maskwood Nexus</li>
        <li>1x Megatog</li>
        <li>1x Mirror Entity</li>
        <li>1x Moritte of the Frost</li>
        <li>4x Mountain</li>
        <li>1x Myriad Landscape</li>
        <li>1x Necratog</li>
        <li>1x One with Nothing</li>
        <li>1x Pact of the Serpent</li>
        <li>1x Path of Ancestry</li>
        <li>1x Phantatog</li>
        <li>4x Plains</li>
        <li>1x Psychatog</li>
        <li>1x Rampant Growth</li>
        <li>1x Realmwalker</li>
        <li>1x Reflections of Littjara</li>
        <li>1x Reliquary Tower</li>
        <li>1x Renounce</li>
        <li>1x Rite of Consumption</li>
        <li>1x Sarcatog</li>
        <li>1x Seat of the Synod</li>
        <li>1x Second Sunrise</li>
        <li>1x Shadowblood Ridge</li>
        <li>1x Smoldering Marsh</li>
        <li>1x Sol Ring</li>
        <li>1x Soul's Fire</li>
        <li>4x Swamp</li>
        <li>1x Taurean Mauler</li>
        <li>1x Temple of Deceit</li>
        <li>1x Temple of Epiphany</li>
        <li>1x Temple of Malice</li>
        <li>1x Terramorphic Expanse</li>
        <li>1x Thaumatog</li>
        <li>1x Universal Automaton</li>
        <li>1x Unsettled Mariner</li>
        <li>1x Vanquisher's Banner</li>
        <li>1x Vault of Whispers</li>
        <li>1x Venomous Changeling</li>
        <li>1x Whispersilk Cloak</li>
        <li>-------------------------</li>
    </ul>)
  }
  const BreyaList = () => {
    return (<ul className='list-none'>
    <li>1x Access Denied</li>
    <li>1x Alibou, Ancient Witness</li>
    <li>1x Ancient Den</li>
    <li>1x Arcane Signet</li>
    <li>1x Arcbound Crusher</li>
    <li>1x Arcum Dagsson</li>
    <li>1x Baleful Strix</li>
    <li>1x Brainstorm</li>
    <li>1x Breya, Etherium Shaper</li>
    <li>1x Cathodion</li>
    <li>1x Chaos Warp</li>
    <li>1x Counterspell</li>
    <li>1x Cranial Plating</li>
    <li>1x Darksteel Citadel</li>
    <li>1x Darksteel Forge</li>
    <li>1x Debt to the Deathless</li>
    <li>1x Dispatch</li>
    <li>1x Drossforge Bridge</li>
    <li>1x Efficient Construction</li>
    <li>1x Encroaching Mycosynth</li>
    <li>1x Esper Sentinel</li>
    <li>1x Etherium Sculptor</li>
    <li>1x Evolving Wilds</li>
    <li>1x Exsanguinate</li>
    <li>1x Fabricate</li>
    <li>1x Foundry Inspector</li>
    <li>1x Great Furnace</li>
    <li>1x Hangarback Walker</li>
    <li>1x Impact Tremors</li>
    <li>1x Ingenious Artillerist</li>
    <li>5x Island</li>
    <li>1x Kappa Cannoneer</li>
    <li>1x Kuldotha Forgemaster</li>
    <li>1x Master of Etherium</li>
    <li>1x Master Transmuter</li>
    <li>1x Mirrodin Besieged</li>
    <li>1x Mistvault Bridge</li>
    <li>1x Mondrak, Glory Dominus</li>
    <li>4x Mountain</li>
    <li>1x Myr Battlesphere</li>
    <li>1x Mystic Monastery</li>
    <li>1x Nettlecyst</li>
    <li>1x Nomad Outpost</li>
    <li>1x One with the Machine</li>
    <li>1x Organic Extinction</li>
    <li>1x Ornithopter of Paradise</li>
    <li>1x Padeem, Consul of Innovation</li>
    <li>1x Pia and Kiran Nalaar</li>
    <li>4x Plains</li>
    <li>1x Power Depot</li>
    <li>1x Prairie Stream</li>
    <li>1x Razortide Bridge</li>
    <li>1x Reckless Fireweaver</li>
    <li>1x Render Silent</li>
    <li>1x Rustvale Bridge</li>
    <li>1x Saheeli, the Gifted</li>
    <li>1x Sai, Master Thopterist</li>
    <li>1x Seat of the Synod</li>
    <li>1x Sharding Sphinx</li>
    <li>1x Silverbluff Bridge</li>
    <li>1x Skullclamp</li>
    <li>1x Sol Ring</li>
    <li>1x Solemn Simulacrum</li>
    <li>1x Soulscour</li>
    <li>1x Spell Swindle</li>
    <li>1x Steel Overseer</li>
    <li>1x Storm the Vault // Vault of Catlacan</li>
    <li>1x Sunken Hollow</li>
    <li>3x Swamp</li>
    <li>1x Sword of the Meek</li>
    <li>1x Swords to Plowshares</li>
    <li>1x Temple of Epiphany</li>
    <li>1x Terramorphic Expanse</li>
    <li>1x Tezzeret, Master of the Bridge</li>
    <li>1x Thopter Assembly</li>
    <li>1x Thopter Engineer</li>
    <li>1x Thopter Foundry</li>
    <li>1x Thopter Spy Network</li>
    <li>1x Thoughtcast</li>
    <li>1x Time Sieve</li>
    <li>1x Trash for Treasure</li>
    <li>1x Tribute Mage</li>
    <li>1x Universal Surveillance</li>
    <li>1x Urza, Lord High Artificer</li>
    <li>1x Vault of Whispers</li>
    <li>1x Vedalken Engineer</li>
    <li>1x Wake the Past</li>
    <li>1x Whir of Invention</li>
    </ul>)
  }

  const ChulaneList = () => {
    return (<ul className='list-none'>
       <li>1x Archaeomancer</li>
       <li>1x Aura Shards</li>
       <li>1x Avacyn's Pilgrim</li>
       <li>1x Azorius Chancery</li>
       <li>1x Beast Whisperer</li>
       <li>1x Birds of Paradise</li>
       <li>1x Cancel</li>
       <li>1x Canopy Vista</li>
       <li>1x Chulane, Teller of Tales</li>
       <li>1x Cloud of Faeries</li>
       <li>1x Cloudstone Curio</li>
       <li>1x Command Tower</li>
       <li>1x Concordant Crossroads</li>
       <li>1x Counterspell</li>
       <li>1x Craterhoof Behemoth</li>
       <li>1x Cultivate</li>
       <li>1x Deputy of Acquittals</li>
       <li>1x Disappearing Act</li>
       <li>1x Dramatic Reversal</li>
       <li>1x Dream Stalker</li>
       <li>1x Eladamri's Call</li>
       <li>1x Elvish Mystic</li>
       <li>1x Elvish Visionary</li>
       <li>1x Eternal Witness</li>
       <li>1x Evolving Wilds</li>
       <li>1x Exotic Orchard</li>
       <li>1x Faeburrow Elder</li>
       <li>1x Faerie Mastermind</li>
       <li>1x Fierce Empath</li>
       <li>1x Finale of Devastation</li>
       <li>1x Forbidding Spirit</li>
       <li>9x Forest</li>
       <li>1x Frilled Mystic</li>
       <li>1x Generous Gift</li>
       <li>1x Growth Spiral</li>
       <li>1x Gyre Engineer</li>
       <li>1x Hallowed Fountain</li>
       <li>1x Heroic Intervention</li>
       <li>1x Inga and Esika</li>
       <li>1x Intruder Alarm</li>
       <li>5x Island</li>
       <li>1x Kiora's Follower</li>
       <li>1x Kodama's Reach</li>
       <li>1x Laboratory Maniac</li>
       <li>1x Leafkin Druid</li>
       <li>1x Llanowar Visionary</li>
       <li>1x Lotus Cobra</li>
       <li>1x Maraleaf Pixie</li>
       <li>1x Moonshaker Cavalry</li>
       <li>1x Mystic Snake</li>
       <li>1x Niambi, Esteemed Speaker</li>
       <li>1x Nyxbloom Ancient</li>
       <li>1x Overwhelming Stampede</li>
       <li>1x Panharmonicon</li>
       <li>1x Paradise Druid</li>
       <li>5x Plains</li>
       <li>1x Prairie Stream</li>
       <li>1x Rampaging Baloths</li>
       <li>1x Rampant Growth</li>
       <li>1x Reclamation Sage</li>
       <li>1x Reliquary Tower</li>
       <li>1x Respite</li>
       <li>1x Retreat to Kazandu</li>
       <li>1x Rewind</li>
       <li>1x Rosethorn Acolyte // Seasonal Ritual</li>
       <li>1x Ruin Crab</li>
       <li>1x Sea of Clouds</li>
       <li>1x Selesnya Sanctuary</li>
       <li>1x Settle the Wreckage</li>
       <li>1x Shrieking Drake</li>
       <li>1x Simic Growth Chamber</li>
       <li>1x Sol Ring</li>
       <li>1x Swiftfoot Boots</li>
       <li>1x Swords to Plowshares</li>
       <li>1x Tatyova, Benthic Druid</li>
       <li>1x Tempest Caller</li>
       <li>1x Temple of Enlightenment</li>
       <li>1x Temple of Mystery</li>
       <li>1x Temple of Plenty</li>
       <li>1x Terramorphic Expanse</li>
       <li>1x Thought Vessel</li>
       <li>1x Whitemane Lion</li>
       <li>1x Woodland Acolyte // Mend the Wilds</li>
       <li>1x Yavimaya Coast</li>
    </ul>)
  }
  const FiresongList = () => {
    return (<ul className='list-none'>
        <li>1x Aetherflux Reservoir</li>
        <li>1x Arcane Signet</li>
        <li>1x Battlefield Forge</li>
        <li>1x Blasphemous Act</li>
        <li>1x Boros Charm</li>
        <li>1x Boros Reckoner</li>
        <li>1x Brash Taunter</li>
        <li>1x Buried Ruin</li>
        <li>1x Chain Reaction</li>
        <li>1x Comet Storm</li>
        <li>1x Command Tower</li>
        <li>1x Darksteel Plate</li>
        <li>1x Dawn of Hope</li>
        <li>1x Deafening Clarion</li>
        <li>1x Dual Casting</li>
        <li>1x Earthquake</li>
        <li>1x Enlightened Tutor</li>
        <li>1x Evolving Wilds</li>
        <li>1x Expedited Inheritance</li>
        <li>1x Faithless Looting</li>
        <li>1x Firesong and Sunspeaker</li>
        <li>1x Furnace of Rath</li>
        <li>1x Furycalm Snarl</li>
        <li>1x Glittering Stockpile</li>
        <li>1x Guilty Conscience</li>
        <li>1x Guttersnipe</li>
        <li>1x Heartflame Duelist // Heartflame Slash</li>
        <li>1x Heliod's Intervention</li>
        <li>1x Heliod, Sun-Crowned</li>
        <li>1x Hit the Mother Lode</li>
        <li>1x Ill-Tempered Loner // Howlpack Avenger</li>
        <li>1x Imperial Recruiter</li>
        <li>1x Indestructibility</li>
        <li>1x Inventors' Fair</li>
        <li>1x Jaya Ballard</li>
        <li>1x Land Tax</li>
        <li>1x Lantern Flare</li>
        <li>1x Leyline Tyrant</li>
        <li>1x Lightning Helix</li>
        <li>1x Magus of the Wheel</li>
        <li>1x Mana Geyser</li>
        <li>1x Molten Disaster</li>
        <li>15x Mountain</li>
        <li>1x Neheb, the Eternal</li>
        <li>1x Nykthos, Shrine to Nyx</li>
        <li>1x Pariah's Shield</li>
        <li>1x Phyrexian Vindicator</li>
        <li>12x Plains</li>
        <li>1x Pyromancer's Goggles</li>
        <li>1x Reconstruct History</li>
        <li>1x Rip Apart</li>
        <li>1x Rolling Earthquake</li>
        <li>1x Seething Song</li>
        <li>1x Shielded by Faith</li>
        <li>1x Smothering Tithe</li>
        <li>1x Sol Ring</li>
        <li>1x Solphim, Mayhem Dominus</li>
        <li>1x Spitemare</li>
        <li>1x Star of Extinction</li>
        <li>1x Starstorm</li>
        <li>1x Storm's Wrath</li>
        <li>1x Stormwild Capridor</li>
        <li>1x Stuffy Doll</li>
        <li>1x Swiftfoot Boots</li>
        <li>1x Swords to Plowshares</li>
        <li>1x Temple of Triumph</li>
        <li>1x Thrill of Possibility</li>
        <li>1x Thrilling Discovery</li>
        <li>1x Torbran, Thane of Red Fell</li>
        <li>1x Treasonous Ogre</li>
        <li>1x Truefire Captain</li>
        <li>1x Unexpected Windfall</li>
        <li>1x Vandalblast</li>
        <li>1x Wojek Investigator</li>
        <li>1x Your Temple Is Under Attack</li>
    </ul>)
  }
  const GeralfList = () => {
    return (<ul className='list-none'>
        <li>1x Academy Ruins</li>
        <li>1x Aether Spellbomb</li>
        <li>1x Aetherflux Reservoir</li>
        <li>1x Arcane Denial</li>
        <li>1x Archmage Emeritus</li>
        <li>1x Brainstorm</li>
        <li>1x Buried Ruin</li>
        <li>1x Case of the Ransacked Lab</li>
        <li>1x Conjurer's Bauble</li>
        <li>1x Consider</li>
        <li>1x Counterspell</li>
        <li>1x Dark Sphere</li>
        <li>1x Darksteel Relic</li>
        <li>1x Deliberate</li>
        <li>1x Distant Melody</li>
        <li>1x Eye of Ramos</li>
        <li>1x Fabricate</li>
        <li>1x Forensic Gadgeteer</li>
        <li>1x Frantic Search</li>
        <li>1x Geralf, the Fleshwright</li>
        <li>1x Geralf, Visionary Stitcher</li>
        <li>1x Gitaxian Probe</li>
        <li>1x God-Eternal Kefnet</li>
        <li>1x Gustha's Scepter</li>
        <li>1x Herbal Poultice</li>
        <li>1x High Tide</li>
        <li>1x Hullbreaker Horror</li>
        <li>1x Hurkyl's Recall</li>
        <li>29x Island</li>
        <li>1x Jason Bright, Glowing Prophet</li>
        <li>1x Jeweled Amulet</li>
        <li>1x Lazotep Plating</li>
        <li>1x Lonely Sandbar</li>
        <li>1x Lotus Petal</li>
        <li>1x Meeting of Minds</li>
        <li>1x Memnite</li>
        <li>1x Mishra's Bauble</li>
        <li>1x Muddle the Mixture</li>
        <li>1x Opt</li>
        <li>1x Ornithopter</li>
        <li>1x Paradise Mantle</li>
        <li>1x Paradoxical Outcome</li>
        <li>1x Peek</li>
        <li>1x Phyrexian Walker</li>
        <li>1x Ponder</li>
        <li>1x Pongify</li>
        <li>1x Poppet Stitcher // Poppet Factory</li>
        <li>1x Preordain</li>
        <li>1x Quick Study</li>
        <li>1x Rapid Hybridization</li>
        <li>1x Rebuild</li>
        <li>1x Reliquary Tower</li>
        <li>1x Retract</li>
        <li>1x Sapphire Medallion</li>
        <li>1x Savor the Moment</li>
        <li>1x Seat of the Synod</li>
        <li>1x Sensei's Divining Top</li>
        <li>1x Serum Visions</li>
        <li>1x Silver Myr</li>
        <li>1x Sol Ring</li>
        <li>1x Spellbook</li>
        <li>1x Swiftfoot Boots</li>
        <li>1x The Reality Chip</li>
        <li>1x Thought Monitor</li>
        <li>1x Thought Vessel</li>
        <li>1x Thoughtcast</li>
        <li>1x Tidespout Tyrant</li>
        <li>1x Tolaria West</li>
        <li>1x Tormod's Crypt</li>
        <li>1x Trinket Mage</li>
        <li>1x Vedalken Archmage</li>
        <li>1x Whispersilk Cloak</li>
    </ul>)
  }
  const GishathList = () => {
    return (<ul className='list-none'>
        <li>1x Akroma's Will</li>
        <li>1x Apex Altisaur</li>
        <li>1x Arcane Signet</li>
        <li>1x Atzocan Seer</li>
        <li>1x Blinding Fog</li>
        <li>1x Bronzebeak Foragers</li>
        <li>1x Canopy Vista</li>
        <li>1x Chandra's Ignition</li>
        <li>1x Cherished Hatchling</li>
        <li>1x Cinder Glade</li>
        <li>1x Clifftop Retreat</li>
        <li>1x Command Tower</li>
        <li>1x Cultivate</li>
        <li>1x Curious Altisaur</li>
        <li>1x Descendants' Path</li>
        <li>1x Dinosaur Egg</li>
        <li>1x Drover of the Mighty</li>
        <li>1x Earthshaker Dreadmaw</li>
        <li>1x Etali, Primal Storm</li>
        <li>1x Evolving Wilds</li>
        <li>1x Exotic Orchard</li>
        <li>1x Farseek</li>
        <li>1x Fierce Empath</li>
        <li>8x Forest</li>
        <li>1x Fortified Village</li>
        <li>1x Furycalm Snarl</li>
        <li>1x Game Trail</li>
        <li>1x Garruk's Uprising</li>
        <li>1x Generous Gift</li>
        <li>1x Ghalta, Stampede Tyrant</li>
        <li>1x Gishath, Sun's Avatar</li>
        <li>1x Goring Ceratops</li>
        <li>1x Growing Rites of Itlimoc // Itlimoc, Cradle of the Sun</li>
        <li>1x Guardian Project</li>
        <li>1x Hulking Raptor</li>
        <li>1x Intrepid Paleontologist</li>
        <li>1x Itzquinth, Firstborn of Gishath</li>
        <li>1x Jungle Shrine</li>
        <li>1x Kessig Wolf Run</li>
        <li>1x Kinjalli's Sunwing</li>
        <li>1x Last March of the Ents</li>
        <li>1x Marauding Raptor</li>
        <li>1x Migration Path</li>
        <li>1x Mosswort Bridge</li>
        <li>4x Mountain</li>
        <li>1x Myriad Landscape</li>
        <li>1x Otepec Huntmaster</li>
        <li>1x Pantlaza, Sun-Favored</li>
        <li>1x Path of Ancestry</li>
        <li>1x Path to Exile</li>
        <li>4x Plains</li>
        <li>1x Poetic Ingenuity</li>
        <li>1x Quartzwood Crasher</li>
        <li>1x Raging Regisaur</li>
        <li>1x Raging Swordtooth</li>
        <li>1x Rampaging Brontodon</li>
        <li>1x Rampant Growth</li>
        <li>1x Ranging Raptors</li>
        <li>1x Regisaur Alpha</li>
        <li>1x Return of the Wildspeaker</li>
        <li>1x Rhythm of the Wild</li>
        <li>1x Ripjaw Raptor</li>
        <li>1x Roaming Throne</li>
        <li>1x Rogue's Passage</li>
        <li>1x Runic Armasaur</li>
        <li>1x Scion of Calamity</li>
        <li>1x Scytheclaw Raptor</li>
        <li>1x Secluded Courtyard</li>
        <li>1x Sol Ring</li>
        <li>1x Sunfrill Imitator</li>
        <li>1x Temple Altisaur</li>
        <li>1x Terramorphic Expanse</li>
        <li>1x The Skullspore Nexus</li>
        <li>1x Thrashing Brontodon</li>
        <li>1x Thriving Grove</li>
        <li>1x Thriving Heath</li>
        <li>1x Thunderherd Migration</li>
        <li>1x Trumpeting Carnosaur</li>
        <li>1x Unclaimed Territory</li>
        <li>1x Vanquisher's Banner</li>
        <li>1x Verdant Sun's Avatar</li>
        <li>1x Wakening Sun's Avatar</li>
        <li>1x Wayward Swordtooth</li>
        <li>1x Wrathful Raptors</li>
        <li>1x Xenagos, God of Revels</li>
        <li>1x Zacama, Primal Calamity</li>
        <li>1x Zetalpa, Primal Dawn</li>
    </ul>)
  }
  const GrenzoList = () => {
    return (<ul className='list-none'>
        <li>1x Ashnod's Altar</li>
        <li>1x Beetleback Chief</li>
        <li>1x Boggart Shenanigans</li>
        <li>1x Bojuka Bog</li>
        <li>1x Bronze Walrus</li>
        <li>1x Buried Ruin</li>
        <li>1x Canyon Slough</li>
        <li>1x Clone Shell</li>
        <li>1x Command Tower</li>
        <li>1x Commander's Sphere</li>
        <li>1x Conjurer's Bauble</li>
        <li>1x Crystal Grotto</li>
        <li>1x Darksteel Pendant</li>
        <li>1x Deadly Dispute</li>
        <li>1x Desecrated Tomb</li>
        <li>1x Dragonskull Summit</li>
        <li>1x Duplicant</li>
        <li>1x Enterprising Scallywag</li>
        <li>1x Epitaph Golem</li>
        <li>1x Evolving Wilds</li>
        <li>1x Exotic Orchard</li>
        <li>1x Faithless Looting</li>
        <li>1x Feed the Swarm</li>
        <li>1x Fire Prophecy</li>
        <li>1x Foreboding Ruins</li>
        <li>1x Frogtosser Banneret</li>
        <li>1x Goblin Charbelcher</li>
        <li>1x Goblin Chieftain</li>
        <li>1x Goblin Chirurgeon</li>
        <li>1x Goblin Matron</li>
        <li>1x Goblin Ringleader</li>
        <li>1x Goblin Warchief</li>
        <li>1x Goblin Welder</li>
        <li>1x Gray Merchant of Asphodel</li>
        <li>1x Grenzo, Dungeon Warden</li>
        <li>1x Hobgoblin Bandit Lord</li>
        <li>1x Hoverstone Pilgrim</li>
        <li>1x Impact Tremors</li>
        <li>1x Impulsive Pilferer</li>
        <li>1x Into the Fire</li>
        <li>1x Junktroller</li>
        <li>1x Krenko, Mob Boss</li>
        <li>1x Legion Warboss</li>
        <li>1x Mad Auntie</li>
        <li>1x Mindmoil</li>
        <li>1x Mogg War Marshal</li>
        <li>1x Molten Collapse</li>
        <li>10x Mountain</li>
        <li>1x Mudbutton Torchrunner</li>
        <li>1x Munitions Expert</li>
        <li>1x Murderous Redcap</li>
        <li>1x Murderous Rider // Swift End</li>
        <li>1x Nefarious Imp</li>
        <li>1x Pashalik Mons</li>
        <li>1x Path of Ancestry</li>
        <li>1x Priest of Gix</li>
        <li>1x Priest of Urabrask</li>
        <li>1x Rakdos Signet</li>
        <li>1x Raucous Theater</li>
        <li>1x Ravenous Chupacabra</li>
        <li>1x Reito Lantern</li>
        <li>1x Shadows of the Past</li>
        <li>1x Siege-Gang Commander</li>
        <li>1x Sinister Waltz</li>
        <li>1x Skirk Fire Marshal</li>
        <li>1x Skirk Prospector</li>
        <li>1x Sling-Gang Lieutenant</li>
        <li>1x Smoldering Marsh</li>
        <li>1x Sol Ring</li>
        <li>10x Swamp</li>
        <li>1x Swiftfoot Boots</li>
        <li>1x Tel-Jilad Stylus</li>
        <li>1x Temple of Malice</li>
        <li>1x The Cauldron of Eternity</li>
        <li>1x Thrill of Possibility</li>
        <li>1x Tormenting Voice</li>
        <li>1x Valakut Awakening // Valakut Stoneforge</li>
        <li>1x Vessel of Endless Rest</li>
        <li>1x Volcanic Spite</li>
        <li>1x Warteye Witch</li>
        <li>1x Whispersilk Cloak</li>
        <li>1x Zoyowa Lava-Tongue</li>
    </ul>)
  }
  const HordeList = () => {
    return (<ul className='list-none'>
        <li>1x Abundance</li>
        <li>1x Animar, Soul of Elements</li>
        <li>1x Animist's Awakening</li>
        <li>1x Arcane Signet</li>
        <li>1x Ashaya, Soul of the Wild</li>
        <li>1x Azorius Guildgate</li>
        <li>1x Baldur's Gate</li>
        <li>1x Bane of Progress</li>
        <li>1x Black Dragon Gate</li>
        <li>1x Boros Guildgate</li>
        <li>1x Brainstorm</li>
        <li>1x Cavalier of Thorns</li>
        <li>1x Chromatic Lantern</li>
        <li>1x Circuitous Route</li>
        <li>1x Citadel Gate</li>
        <li>1x Command Tower</li>
        <li>1x Commander's Sphere</li>
        <li>1x Counterspell</li>
        <li>1x Crop Rotation</li>
        <li>1x Cultivator Colossus</li>
        <li>1x Dig Up</li>
        <li>1x Dimir Guildgate</li>
        <li>1x District Guide</li>
        <li>1x Dryad of the Ilysian Grove</li>
        <li>1x Evolving Wilds</li>
        <li>1x Explore</li>
        <li>1x Faeburrow Elder</li>
        <li>1x Flamekin Harbinger</li>
        <li>1x Flickerwisp</li>
        <li>6x Forest</li>
        <li>1x Gatecreeper Vine</li>
        <li>1x Gates Ablaze</li>
        <li>1x Genesis Ultimatum</li>
        <li>1x Geode Rager</li>
        <li>1x Golgari Guildgate</li>
        <li>1x Gond Gate</li>
        <li>1x Greenside Watcher</li>
        <li>1x Growth Spiral</li>
        <li>1x Gruul Guildgate</li>
        <li>1x Guild Summit</li>
        <li>1x Horde of Notions</li>
        <li>3x Island</li>
        <li>1x Izzet Guildgate</li>
        <li>1x Lotus Cobra</li>
        <li>1x Maelstrom Wanderer</li>
        <li>1x Magma Pummeler</li>
        <li>1x Manor Gate</li>
        <li>1x Maze's End</li>
        <li>4x Mountain</li>
        <li>1x Muldrotha, the Gravetide</li>
        <li>1x Mulldrifter</li>
        <li>1x Multani, Yavimaya's Avatar</li>
        <li>1x Nylea's Intervention</li>
        <li>1x Omnath, Locus of Creation</li>
        <li>1x Omnath, Locus of Rage</li>
        <li>1x Omnath, Locus of the Roil</li>
        <li>1x Open the Gates</li>
        <li>1x Open the Way</li>
        <li>1x Orzhov Guildgate</li>
        <li>1x Phylath, World Sculptor</li>
        <li>3x Plains</li>
        <li>1x Rakdos Guildgate</li>
        <li>1x Ramunap Excavator</li>
        <li>1x Reshape the Earth</li>
        <li>1x Rewind</li>
        <li>1x Risen Reef</li>
        <li>1x Rites of Flourishing</li>
        <li>1x Roil Elemental</li>
        <li>1x Ruinous Ultimatum</li>
        <li>1x Scapeshift</li>
        <li>1x Sea Gate</li>
        <li>1x Selesnya Guildgate</li>
        <li>1x Shriekmaw</li>
        <li>1x Simic Guildgate</li>
        <li>1x Sol Ring</li>
        <li>1x Soul of the Harvest</li>
        <li>1x Splendid Reclamation</li>
        <li>1x Summer Bloom</li>
        <li>3x Swamp</li>
        <li>1x Swords to Plowshares</li>
        <li>1x Sylvan Scrying</li>
        <li>1x Tangled Florahedron // Tangled Vale</li>
        <li>1x Tempt with Discovery</li>
        <li>1x Titania, Protector of Argoth</li>
        <li>1x Vigor</li>
        <li>1x Wispmare</li>
    </ul>)
  }
  const MerenList = () => {
    return (<ul className='list-none'>
        <li>1x Animate Dead</li>
        <li>1x Arcane Signet</li>
        <li>1x Ashnod's Altar</li>
        <li>1x Assassin's Trophy</li>
        <li>1x Avenger of Zendikar</li>
        <li>1x Bala Ged Recovery // Bala Ged Sanctuary</li>
        <li>1x Bastion of Remembrance</li>
        <li>1x Braids, Arisen Nightmare</li>
        <li>1x Buried Alive</li>
        <li>1x Cabal Coffers</li>
        <li>1x Cankerbloom</li>
        <li>1x Castle Locthwain</li>
        <li>1x Caustic Caterpillar</li>
        <li>1x Chupacabra Echo</li>
        <li>1x Command Tower</li>
        <li>1x Conduit of Worlds</li>
        <li>1x Cultivate</li>
        <li>1x Dawntreader Elk</li>
        <li>1x Deathcap Cultivator</li>
        <li>1x Doomed Necromancer</li>
        <li>1x Dread Summons</li>
        <li>1x Eternal Witness</li>
        <li>1x Evolving Wilds</li>
        <li>1x Exotic Orchard</li>
        <li>1x Fauna Shaman</li>
        <li>1x Fiend Artisan</li>
        <li>9x Forest</li>
        <li>1x Gaze of Granite</li>
        <li>1x Geier Reach Sanitarium</li>
        <li>1x Golgari Findbroker</li>
        <li>1x Grave Pact</li>
        <li>1x Gravepurge</li>
        <li>1x Gray Merchant of Asphodel</li>
        <li>1x Grim Backwoods</li>
        <li>1x Izoni, Thousand-Eyed</li>
        <li>1x Jarad, Golgari Lich Lord</li>
        <li>1x Junji, the Midnight Sky</li>
        <li>1x Kodama's Reach</li>
        <li>1x Kokusho, the Evening Star</li>
        <li>1x Leyline Prowler</li>
        <li>1x Lord of Extinction</li>
        <li>1x Malakir Rebirth // Malakir Mire</li>
        <li>1x Meren of Clan Nel Toth</li>
        <li>1x Midnight Reaper</li>
        <li>1x Mikaeus, the Unhallowed</li>
        <li>1x Mosswood Dreadknight // Dread Whispers</li>
        <li>1x Old Stickfingers</li>
        <li>1x Pitiless Plunderer</li>
        <li>1x Protean Hulk</li>
        <li>1x Reanimate</li>
        <li>1x Reassembling Skeleton</li>
        <li>1x Reclamation Sage</li>
        <li>1x Reincarnation</li>
        <li>1x Savra, Queen of the Golgari</li>
        <li>1x Sheoldred, Whispering One</li>
        <li>1x Shriekmaw</li>
        <li>1x Sidisi, Undead Vizier</li>
        <li>1x Skull Prophet</li>
        <li>1x Slimefoot, the Stowaway</li>
        <li>1x Sol Ring</li>
        <li>1x Splinterfright</li>
        <li>1x Spore Frog</li>
        <li>1x Stitch Together</li>
        <li>9x Swamp</li>
        <li>1x Swiftfoot Boots</li>
        <li>1x Syr Konrad, the Grim</li>
        <li>1x Tainted Wood</li>
        <li>1x Talisman of Resilience</li>
        <li>1x Temple of Malady</li>
        <li>1x Terramorphic Expanse</li>
        <li>1x The Mycotyrant</li>
        <li>1x Underground Mortuary</li>
        <li>1x Underrealm Lich</li>
        <li>1x Urborg, Tomb of Yawgmoth</li>
        <li>1x Victimize</li>
        <li>1x Village Rites</li>
        <li>1x Viridian Emissary</li>
        <li>1x Viscera Seer</li>
        <li>1x Volatile Fault</li>
        <li>1x Walking Ballista</li>
        <li>1x Wight of Precinct Six</li>
        <li>1x Witch's Cottage</li>
        <li>1x Woodland Cemetery</li>
        <li>1x Yavimaya Elder</li>
    </ul>)
  }
  const OkaunList = () => {
    return (<ul className='list-none'>
        <li>1x Academy Ruins</li>
        <li>1x Arcane Signet</li>
        <li>1x Blasphemous Act</li>
        <li>1x Boompile</li>
        <li>1x Buried Ruin</li>
        <li>1x Cascade Bluffs</li>
        <li>1x Chance Encounter</li>
        <li>1x Chandra's Ignition</li>
        <li>1x Chaos Warp</li>
        <li>1x Command Tower</li>
        <li>1x Commander's Plate</li>
        <li>1x Counterspell</li>
        <li>1x Creepy Doll</li>
        <li>1x Crooked Scales</li>
        <li>1x Daretti, Scrap Savant</li>
        <li>1x Desolate Lighthouse</li>
        <li>1x Embercleave</li>
        <li>1x Exotic Orchard</li>
        <li>1x Fabricate</li>
        <li>1x Fiery Gambit</li>
        <li>1x Flamekin Village</li>
        <li>1x Footfall Crater</li>
        <li>1x Frenetic Sliver</li>
        <li>1x Gamble</li>
        <li>1x Game of Chaos</li>
        <li>1x Goblin Archaeologist</li>
        <li>1x Goblin Engineer</li>
        <li>1x Goblin Kaboomist</li>
        <li>1x Goblin Traprunner</li>
        <li>1x Great Furnace</li>
        <li>1x Impulsive Maneuvers</li>
        <li>1x Inventors' Fair</li>
        <li>1x Irenicus's Vile Duplication</li>
        <li>7x Island</li>
        <li>1x Izzet Boilerworks</li>
        <li>1x Izzet Signet</li>
        <li>1x Karplusan Minotaur</li>
        <li>1x Krark's Thumb</li>
        <li>1x Krark, the Thumbless</li>
        <li>1x Lightning Greaves</li>
        <li>1x Long-Term Plans</li>
        <li>1x Mana Clash</li>
        <li>1x Mind Stone</li>
        <li>1x Mirror March</li>
        <li>1x Mogg Assassin</li>
        <li>1x Molten Birth</li>
        <li>9x Mountain</li>
        <li>1x Muddle the Mixture</li>
        <li>1x Mutalith Vortex Beast</li>
        <li>1x Myriad Landscape</li>
        <li>1x Negate</li>
        <li>1x Okaun, Eye of Chaos</li>
        <li>1x Path of Ancestry</li>
        <li>1x Planar Chaos</li>
        <li>1x Ponder</li>
        <li>1x Preordain</li>
        <li>1x Ral Zarek</li>
        <li>1x Reliquary Tower</li>
        <li>1x Reshape</li>
        <li>1x Rogue's Passage</li>
        <li>1x Sakashima the Impostor</li>
        <li>1x Seize the Day</li>
        <li>1x Serum Visions</li>
        <li>1x Shadowspear</li>
        <li>1x Shivan Reef</li>
        <li>1x Slip Through Space</li>
        <li>1x Sol Ring</li>
        <li>1x Soul's Fire</li>
        <li>1x Spark Double</li>
        <li>1x Squee's Revenge</li>
        <li>1x Stitch in Time</li>
        <li>1x Sulfur Falls</li>
        <li>1x Swiftfoot Boots</li>
        <li>1x Sword of Vengeance</li>
        <li>1x Talisman of Creativity</li>
        <li>1x Tavern Scoundrel</li>
        <li>1x Temple of Epiphany</li>
        <li>1x Temur Battle Rage</li>
        <li>1x Thought Vessel</li>
        <li>1x Tolaria West</li>
        <li>1x Training Center</li>
        <li>1x Tribute Mage</li>
        <li>1x Vandalblast</li>
        <li>1x Wandering Fumarole</li>
        <li>1x Whir of Invention</li>
        <li>1x Whispersilk Cloak</li>
        <li>1x Yusri, Fortune's Flame</li>
        <li>1x Zndrsplt, Eye of Wisdom</li>
    </ul>)
  }
  const RinSeriList = () => {
    return (<ul className='list-none'>
        <li>1x Alms Collector</li>
        <li>1x Anointed Procession</li>
        <li>1x Arcane Signet</li>
        <li>1x Austere Command</li>
        <li>1x Beast Whisperer</li>
        <li>1x Beastmaster Ascension</li>
        <li>1x Bronzehide Lion</li>
        <li>1x Buried Ruin</li>
        <li>1x Canopy Vista</li>
        <li>1x Chord of Calling</li>
        <li>1x Cinder Glade</li>
        <li>1x Command Tower</li>
        <li>1x Crib Swap</li>
        <li>1x Domri, Anarch of Bolas</li>
        <li>1x Evolving Wilds</li>
        <li>1x Exotic Orchard</li>
        <li>1x Felidar Cub</li>
        <li>1x Felidar Retreat</li>
        <li>1x Feline Sovereign</li>
        <li>10x Forest</li>
        <li>1x Furycalm Snarl</li>
        <li>1x Gavony Township</li>
        <li>1x Generous Stray</li>
        <li>1x Healer of the Pride</li>
        <li>1x Heroic Intervention</li>
        <li>1x Hour of Reckoning</li>
        <li>1x Hungry Lynx</li>
        <li>1x Impact Tremors</li>
        <li>1x Impostor of the Sixth Pride</li>
        <li>1x Jazal Goldmane</li>
        <li>1x Jetmir, Nexus of Revels</li>
        <li>1x Jinnie Fay, Jetmir's Second</li>
        <li>1x Kaheera, the Orphanguard</li>
        <li>1x Keeper of Fables</li>
        <li>1x Kessig Wolf Run</li>
        <li>1x King of the Pride</li>
        <li>1x Kodama's Reach</li>
        <li>1x Kutzil's Flanker</li>
        <li>1x Kutzil, Malamet Exemplar</li>
        <li>1x Leonin Warleader</li>
        <li>1x Lifecrafter's Bestiary</li>
        <li>1x Lion Sash</li>
        <li>1x Loyal Warhound</li>
        <li>1x Make a Stand</li>
        <li>1x Mirror Entity</li>
        <li>1x Moonshaker Cavalry</li>
        <li>5x Mountain</li>
        <li>1x Oketra's Monument</li>
        <li>1x Oreskos Explorer</li>
        <li>1x Overrun</li>
        <li>1x Overwhelming Stampede</li>
        <li>1x Pack Leader</li>
        <li>1x Path of Ancestry</li>
        <li>1x Path to Exile</li>
        <li>9x Plains</li>
        <li>1x Prava of the Steel Legion</li>
        <li>1x Pride Sovereign</li>
        <li>1x Prowling Serpopard</li>
        <li>1x Qasali Slingers</li>
        <li>1x Rampant Growth</li>
        <li>1x Regal Caracal</li>
        <li>1x Resolute Watchdog</li>
        <li>1x Rin and Seri, Inseparable</li>
        <li>1x Rockfall Vale</li>
        <li>1x Shared Animosity</li>
        <li>1x Sol Ring</li>
        <li>1x Spirited Companion</li>
        <li>1x Stalking Leonin</li>
        <li>1x Swiftfoot Boots</li>
        <li>1x Swords to Plowshares</li>
        <li>1x Temple of Plenty</li>
        <li>1x Temple of Triumph</li>
        <li>1x Terramorphic Expanse</li>
        <li>1x Thrill of Possibility</li>
        <li>1x Titanic Ultimatum</li>
        <li>1x To Arms!</li>
        <li>1x Unbreakable Formation</li>
        <li>1x Vanquisher's Banner</li>
        <li>1x Whitemane Lion</li>
    </ul>)
  }
  export {
    AtogList,
    BreyaList,
    ChulaneList,
    FiresongList,
    GeralfList,
    GishathList,
    GrenzoList,
    HordeList,
    MerenList,
    OkaunList,
    RinSeriList
  };